module.exports = __webpack_public_path__ + "static/media/badge1.eebc002a.png";